import { connection_platform } from "../services/api";

let gethostname = window.location.hostname;
let pathname = "";

let iplocal = connection_platform.ip_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

if (connection_platform.client_differentip === true)
  pathname = connection_platform.ip_extern;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

const urlIngWeb = `${connection_platform.type_connect}://${ipcurrent}`;

export default urlIngWeb;
